import React, { useRef, useState } from 'react';
import { StatOptions } from 'fs';
// import Dropdown from 'react-dropdown';
import { RiderModel, Riders_PackagesModel, RiderPackageServiceModel, Riders_PackagesAuthorizationNumberModel, PaymentModel } from '../models/superbit-api-models'
import { SubscribersModel } from '../models/SubscribersModel'
import '../assets/css/subscribers_p0004.css'
import { Menu } from '../_Menu'
import Header from '../Header';
import Footer from '../_Footer'
import moment from 'moment';
// import { RidersData } from './Subscribers'
import { Tooltip } from 'antd';
import {RidersData} from './SubscriberHelper'


type Props = {
    data: RiderModel | null;
    LastVersion: RidersData | undefined;
    all: RiderModel[];
    isChild: boolean;
    OnEditClick: Function;
    OnActiveClick:Function;
    onUpdateDetailsClick: Function;
    onUpdatePackagesClick: Function;
    onChangeVehicleClick: Function;
    onUpdatePaymentsClick: Function;
    createServiceReporter: Function;
    onEditEndDateClick: Function;
    onShowLogClick: Function;
    setRenNewRider: Function;
    setPopUpType: Function;
};
type State = {
    showBtnOptions: false;
    open: false;
    rider?: RiderModel;
};


const options = [
    'one', 'two', 'three'
];

export class Subscriber extends React.Component<Props> {
    state: State = {
        showBtnOptions: false,
        open: false
    };

    myRef: React.RefObject<unknown>;

    constructor(props: any) {
        super(props);
        this.myRef = React.createRef();
        this.setState({ rider: this.props.data })
    }


    componentDidMount() {
        document.addEventListener('click', this.handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener('click', this.handleClickOutside);
    }

    handleClickOutside = (event: any) => {
        if (this.myRef.current && !(this.myRef.current as any).contains(event.target)) {
            // The user clicked outside of the component
            this.showBtnMenu(false);
        }
    };

    getPackaged() {
        if (this.props.data != null && this.props.data.riderPackages != null) {
            return this.props.data.riderPackages.map((p: Riders_PackagesModel) => {
                return (p.riderPackage != null ? p.riderPackage.name + ',' : "");
            })
        }
        return "";
    }

    getStatus() {
        if (this.props.data != null && this.props.data.riderPackages != null) {

            if (this.props.isChild && !this.props.LastVersion) {
                return "לא פעיל"

            }


            var status = "";
            var hasNull = false;
            this.props.data.riderPackages.filter((p: Riders_PackagesModel) => {
                // if (p.authorizationNumbers == null || p.authorizationNumbers == undefined || p.authorizationNumbers.length == 0)
                //     hasNull = false;

                //RiderStatusTypeFilter = b => b.RiderPackages.Any(x => x.AuthorizationNumbers.Where(y => y.AuthorizationNumber == null).Count() > 0);
                if (p.authorizationNumbers != null && p.authorizationNumbers.length > 0 && p.authorizationNumbers.filter(a => a.authorizationNumber == null).length > 0)
                    hasNull = true;
                // else
                //     hasNull = false;

                //return (p.authorizationNumbers != null && p.authorizationNumbers.length > 0 ? p.authorizationNumbers.filter((a: Riders_PackagesAuthorizationNumberModel) => a == null).length > 0 ? true : false : false);
            });
            if (hasNull)
                return "לא נרשם בממסי";

            if (this.props.data.riderStatusType == 0 && this.props.data.endDate != null && this.props.data.endDate < new Date())//active
                return "לא בתוקף";
            if (this.props.data.riderStatusType == 0)
                return "פעיל";
            if (this.props.data.riderStatusType == 1)
                return "מוקפא";
            if (this.props.data.riderStatusType == 2)
                return "ביטול";
            if (this.props.data.riderStatusType == 3)
                return "עוד לא פעיל";
            if (this.props.data.riderStatusType == 4)
                return "בוטל טרם הפקה";

            return this.props.data.riderStatusType;

        }
    }

    getPayments() {
        var paid = true;



        if (this.props.data != null && this.props.data.payments != null) {

            if (!this.props.isChild) {

                if ((this.props.all && this.props.all.find((y: RiderModel) => y.payments && y.payments.filter((p: PaymentModel) => p.creationStatus == 0).some((p: PaymentModel) => p.paymentStatus === 1)))
                    && (this.props.all && this.props.all.find((y: RiderModel) => y.payments && y.payments.filter((p: PaymentModel) => p.creationStatus == 0).some((p: PaymentModel) => p.paymentStatus === 0)))) {
                    return ""

                }

                if ((this.props.all && this.props.all.find((y: RiderModel) => y.payments && y.payments.filter((p: PaymentModel) => p.creationStatus == 0).some((p: PaymentModel) => p.paymentStatus === 0)))) {
                    return "לא שולם"

                }







                return "שולם";

            }








            if (this.props.data.payments.filter((p: PaymentModel) => p.creationStatus == 0 && (p.paymentStatus == 2 || p.paymentStatus === 0)).length == this.props.data.payments.filter((p: PaymentModel) => p.creationStatus == 0).length) {
                return "לא שולם"
            }
            if (this.props.data.payments.filter((p: PaymentModel) => p.creationStatus == 0 && (p.paymentStatus == 2 || p.paymentStatus === 1)).length == this.props.data.payments.filter((p: PaymentModel) => p.creationStatus == 0).length) {
                return "שולם"
            }
            if (this.props.data.payments.filter((p: PaymentModel) => p.creationStatus == 0 && (p.paymentStatus == 2)).length == this.props.data.payments.filter((p: PaymentModel) => p.creationStatus == 0).length) {
                return "בוטל"
            }
            return "";

        }
    }

    getAmount() {

        var sum = 0;


        if (this.props.data && this.props.data.payments) {
            if (this.props.data.subscriberNumber && this.props.data.subscriberNumber == 10020706) {
                // 
            }
            if (!this.props.isChild) {
                sum = this.props.data.payments.filter(x => x.paymentStatus != 2).map(x => x.amount || 0).reduce((sum, amount) => sum + amount, 0);

            }
            else {
                if (this.props.data.payments.filter(x => x.paymentStatus == 0).length > 0) {
                    let p = this.props.data.payments.filter(x => x.creationStatus == 0 && x.paymentStatus != 2);
                    var sum = this.props.data.payments ? this.props.data.payments.filter(x => x.creationStatus == 0 && x.paymentStatus == 1).map(x => x.amount ? x.amount * -1 : 0)                                     // Transform to amounts
                        .reduce((sum, amount) => sum + amount, 0) : 0;
                    sum += this.props.data.payments ? this.props.data.payments.filter(x => x.creationStatus == 0 && x.paymentStatus == 0).map(x => x.amount || 0)                                     // Transform to amounts
                        .reduce((sum, amount) => sum + amount, 0) : 0;

                    if (this.props.all.filter(x => x.additionNumber && this.props.data && this.props.data.additionNumber && x.additionNumber < this.props.data.additionNumber).length > 0) {
                        var lastVersion = this.props.all.filter(x => x.additionNumber && this.props.data && this.props.data.additionNumber && x.additionNumber < this.props.data.additionNumber).reduce((max, obj) =>
                            obj.additionNumber && max.additionNumber && obj.additionNumber > max.additionNumber ? obj : max
                        );
                        if (lastVersion != null && lastVersion.payments && lastVersion.payments.filter(x => x.creationStatus == 0 && x.paymentStatus == 2).length > 0) {

                            sum -= lastVersion.payments.filter(x => x.creationStatus == 0 && x.paymentStatus == 2).map(x => x.amount || 0).reduce((sum, amount) => sum + amount, 0);

                        }
                    }


                }
                else if (this.props.data.payments.filter(x => x.paymentStatus == 2).length == this.props.data.payments.length) {
                    sum = this.props.data.payments.filter(x => x.creationStatus == 0).map(x => x.amount || 0).reduce((sum, amount) => sum + amount, 0);
                }
                else {

                    var p = this.props.data.payments.filter(x => x.creationStatus == 0 && x.paymentStatus != 2).map(x => x.amount || 0).reduce((sum, amount) => sum + amount, 0);
                    if (this.props.data.additionNumber && this.props.data.additionNumber > 0) {
                        var addNumber = this.props.data.additionNumber;

                        if (this.props.all.filter(x => x.additionNumber && this.props.data && this.props.data.additionNumber && x.additionNumber < this.props.data.additionNumber).length > 0) {
                            var lastVersion = this.props.all.filter(x => x.additionNumber && this.props.data && this.props.data.additionNumber && x.additionNumber < this.props.data.additionNumber).reduce((max, obj) =>
                                obj.additionNumber && max.additionNumber && obj.additionNumber > max.additionNumber ? obj : max
                            );
                            if (lastVersion != null)
                                if (lastVersion != null && lastVersion.payments && lastVersion.payments.filter(x => x.creationStatus == 0 && x.paymentStatus == 2).length > 0) {

                                    p -= lastVersion.payments.filter(x => x.creationStatus == 0 && x.paymentStatus == 2).map(x => x.amount || 0).reduce((sum, amount) => sum + amount, 0);

                                }
                        }
                    }
                    sum = p;
                }
            }
        }
        return Math.round(sum);
    }


    showBtnMenu(show: boolean) {
        this.setState({
            showBtnOptions: show ? true : false
        })
    }

    toggleBtnMenu() {
        const cuurentState = this.state.showBtnOptions;
        this.setState({
            showBtnOptions: !cuurentState
        })
        // console.log(this.props.all)
    }

    onMenuClick(action: string) {
        console.log(action);
        switch (action) {
            case 'activeDetails':
                this.props.OnActiveClick();
                break;
            case 'edit':
                this.props.OnEditClick();
                break;
            case 'editDetails':
                this.props.onUpdateDetailsClick();
                break;
            case 'editPackages':
                this.props.onUpdatePackagesClick();
                break;
            case 'changeVehicle':
                this.props.onChangeVehicleClick(this.props.data);
                break;
            case 'editPayments':
                this.props.onUpdatePaymentsClick();
                break;
            case 'serviceReporter':
                this.props.createServiceReporter();
                break;
            case 'editEndDate':
                this.props.onEditEndDateClick();
                break;
            case 'showLog':
                this.props.onShowLogClick(this.props.data);
                break;
            case 'renewRider':
                if (this.props.data) {
                    console.log('this.props.data.id', this.props.data)
                    this.props.setRenNewRider(this.props.data);
                    this.props.setPopUpType('renew');
                }
                break;


            default:
                break;
        }
        this.toggleBtnMenu()
    }
    // onEditClick ()  {
    //     this.props.onEditClick(this.props.data);
    // }



    onArrowClick = () => {
        const currStatus = this.state.open;
        this.setState({ open: !currStatus });
    }

    getAdditionNumber(n: number | undefined) {
        if (n != undefined) {
            if (n < 10)
                return "0" + n;
            return n + "";
        }
        return "";
    }

    renderChildren() {
        if (!this.props.isChild) {

            // if(this.props.data && this.props.data.subscriberNumber==10020435){
            //     
            // }
            var children = [];
            if (this.props.data) {
                children.push(new RidersData(this.props.data, this.props.LastVersion, this.props.all));

                var lastVersion = this.props.LastVersion;

                while (lastVersion) {
                    children.push(lastVersion);
                    lastVersion = lastVersion.oldVersionRiders;
                }

                // show in reverse order
                const newChildren = children.reverse();

                if (newChildren.length > 1) {
                    return (
                        <>
                            {newChildren
                                .filter((item): item is RidersData => item !== undefined) // This ensures only valid `RidersData` items are mapped
                                .map((item: RidersData, index: number) => (
                                    <Subscriber
                                        data={item.rider}
                                        LastVersion={item.oldVersionRiders}
                                        all={item.all}
                                        isChild={true}
                                        key={index}
                                        OnEditClick={() => []}
                                        OnActiveClick={() => []}
                                        onUpdateDetailsClick={() => []}
                                        onUpdatePackagesClick={() => []}
                                        onUpdatePaymentsClick={() => []}
                                        onChangeVehicleClick={() => []}
                                        createServiceReporter={() => []}
                                        onEditEndDateClick={() => []}
                                        onShowLogClick={() => this.props.onShowLogClick(item.rider)}
                                        setRenNewRider={this.props.setRenNewRider}
                                        setPopUpType={this.props.setPopUpType}
                                    />
                                ))}
                        </>
                    );
                }
            }

        }

        return "";


    }

    isAdmin = () => {
        let loggedUser: any = localStorage.getItem('loggedUser');
        if (loggedUser) {
            loggedUser = JSON.parse(loggedUser);
            return loggedUser.role == 0
        }
        return false;
    }

    isValidUrl = (input: string): boolean => {
        const urlPattern = /^(https?:\/\/)?([\w-]+(\.[\w-]+)+)(\/[\w-]*)*(\?.*)?(#.*)?$/i;
        return urlPattern.test(input);
    }

    isHTML = (str: string): boolean => {
        const htmlPattern = /<\/?[a-z][\s\S]*>/i;
        return htmlPattern.test(str);
    }




    render() {
        return (
            <>
                {this.props.data != null ? (
                    <>
                        <div className="data-card " style={{ display: 'flex' }}>
                            {this.props.isChild ? <div className="policy-empty-right-cell "><div className="icon policy-right-icon"></div></div> : ""}

                            <div className="data-card-body " style={{ display: 'flex', }}>
                                <div style={{ minWidth: '40px', maxWidth: '40px', }}>

                                    <div className={`description cell-value on-click-ignore  ${!this.props.isChild && this.props.all && this.props.all.length > 1 ? '' : 'hide'}`}>
                                        {this.state.open ? (
                                            <div className='icon squire-minus pointer' onClick={this.onArrowClick}></div>
                                        ) : (<></>)}
                                        {!this.state.open ? (
                                            <div className='icon squire-plus pointer' onClick={this.onArrowClick}></div>
                                        ) : (<></>)}
                                    </div>
                                </div>
                                <div
                                    // className="cell"
                                    style={{ width: '120px', textAlign: 'right' }}
                                >

                                    <div className="description cell-value ltrDirection">
                                        {this.props.data.subscriberNumber}
                                        {this.props.isChild ? `\\${this.getAdditionNumber(this.props.data.additionNumber)}` : ""}

                                    </div>
                                </div>
                                <div
                                    // className="cell"
                                    style={{ width: '150px', textAlign: 'right' }}
                                >

                                    <div className="description cell-value" style={{ whiteSpace: 'initial' }}>
                                        {this.props.data.customer != null ? this.props.data.customer.fullName : ""}
                                    </div>
                                </div>
                                <div
                                    // className="cell"
                                    style={{ width: '120px', textAlign: 'right' }}
                                >

                                    <div className="description cell-value">
                                        {this.props.data.customer != null ? this.props.data.customer.identifier : ""}
                                    </div>
                                </div>
                                <div
                                    // className="cell"
                                    style={{ width: '120px', textAlign: 'right' }}
                                >

                                    <div className="description cell-value">
                                        {this.props.data.vehicle != null ? this.props.data.vehicle.licenseNumber : ""}
                                    </div>
                                </div>
                                <div
                                    // className="cell"
                                    style={{ width: '250px', textAlign: 'right' }}
                                >

                                    <div className="description cell-value" style={{ whiteSpace: 'initial', paddingLeft: '20px', fontWeight: 'unset' }}>
                                        {this.getPackaged()}
                                    </div>
                                </div>
                                <div
                                    // className="cell date"
                                    style={{ width: '130px', textAlign: 'right' }}
                                >

                                    <div className="description cell-value" style={{ fontWeight: 'unset' }}>
                                        {moment(this.props.data.createdDate).format('DD-MM-YYYY')}
                                    </div>
                                </div>
                                <div
                                    // className="cell date"
                                    style={{ width: '130px', textAlign: 'right' }}
                                >

                                    <div className="description cell-value" style={{ fontWeight: 'unset' }}>
                                        {this.props.data.updateStartDate && this.props.data.startDate != null && moment(this.props.data.updateStartDate).format('DD-MM-YYYY') != '01-01-0001' && this.props.isChild ?
                                            moment(this.props.data.updateStartDate).format('DD-MM-YYYY') : moment(this.props.data.startDate).format('DD-MM-YYYY')
                                        }
                                        {/* {moment(this.props.data.startDate).format('DD-MM-YYYY')} */}
                                    </div>
                                </div>
                                <div
                                    // className="cell date"
                                    style={{ width: '130px', textAlign: 'right' }}
                                >
                                    <div className="description cell-value" style={{ fontWeight: 'unset' }}>
                                        {moment(this.props.data.endDate).format('DD-MM-YYYY')}
                                    </div>
                                </div>
                                <div
                                    // className="cell status"
                                    style={{ width: '120px', textAlign: 'right' }}
                                >
                                    <div className="description cell-value" style={{ fontWeight: 'unset' }}>
                                        {this.getStatus()}
                                    </div>
                                </div>
                                <div
                                    // className="cell"
                                    style={{ width: '120px', textAlign: 'right' }}
                                >

                                    <div className="description cell-value" style={{ fontWeight: 'unset' }}>
                                        {/* {this.props.data.comment != null ? this.props.data.comment : ""} */}
                                        {this.props.data && this.props.data.comment  ? (<>
                                <Tooltip title={() => {
                                    return (this.props.data?.comment && this.isValidUrl(this.props.data.comment) ?
                                        <a target="_blank" href={this.props.data.comment}>{this.props.data.comment}</a>
                                        :
                                        this.props.data?.comment && (
                                            this.isHTML(this.props.data?.comment) ? (
                                                <div dangerouslySetInnerHTML={{ __html: this.props.data?.comment }} />
                                            ) :
                                                <>
                                                    {this.props.data?.comment}
                                                </>
                                        )
                                    )
                                }} color={'#027BFD'} placement="right">
                                    {/* {treatmentNote} */}
                                    <div className="icon comment"></div>
                                    {/* comment */}
                                </Tooltip>


                            </>) : (<>

                            </>)}
                                    </div>
                                </div>
                                <div
                                    // className="cell"
                                    style={{ width: '120px', textAlign: 'right' }}
                                >

                                    <div className="description cell-value" style={{ fontWeight: 'unset' }}>
                                        {this.getPayments()}
                                    </div>
                                </div>
                                <div
                                    style={{ width: '120px', textAlign: 'right' }}
                                // className="cell"
                                >

                                    <div className="description cell-value" style={{ fontWeight: 'unset' }}>
                                        {this.getAmount()}
                                    </div>
                                </div>
                                <div
                                    // className="cell"
                                    style={{ width: '140px', textAlign: 'right' }}
                                >

                                    <div className="description cell-value" style={{ fontWeight: 'unset' }}>
                                        {this.props.data.handlerName}
                                    </div>
                                </div>
                                <div className={this.props.isChild ? "hide" : "cell actions with-menu"}>
                                    <div className={this.props.isChild ? "hide" : 'act-btn-icon icon menu-hamburger pointer'} style={{ marginRight: '20px' }}
                                        // <button className={this.props.isChild ? "hide" : "act-btn has-icon has-menu flex-centered flex-justify-center"}
                                        onClick={() => { this.toggleBtnMenu() }}
                                    >
                                    </div>
                                    {/* פעולות
                                        <div className="icon down-arrow"></div>
                                    </button> */}



                                    {this.state.showBtnOptions && (
                                        <ul className="btn-menu">
                                            {/* <li className="pointer"
                                        onClick={()=>{this.onMenuClick('edit')}}
                                    >
                                        ערוך
                                    </li> */}

                                            <li className={this.props.data.riderStatusType == 3 ? "pointer" : "hide"}
                                                onClick={() => { this.onMenuClick('activeDetails') }}
                                            >
                                                הפעלת מנוי                                            </li>

                                            <li className={this.props.data.riderStatusType != 2 ? "pointer" : "hide"}
                                                onClick={() => { this.onMenuClick('editDetails') }}
                                            >
                                                ערוך פרטים
                                            </li>
                                            <li className={this.props.data.riderStatusType != 2 && (this.props.data.endDate && this.props.data.endDate > new Date()) ? "pointer" : "hide"}
                                                onClick={() => { this.onMenuClick('editPackages') }}
                                            >
                                                ערוך חבילות
                                            </li>
                                            <li className={this.props.data.riderStatusType != 2 && (this.props.data.endDate && this.props.data.endDate > new Date()) ? "pointer" : "hide"}
                                                onClick={() => { this.onMenuClick('changeVehicle') }}
                                            >
                                                החלף רכב
                                            </li>
                                            <li className="pointer"
                                                onClick={() => { this.onMenuClick('editPayments') }}
                                            >
                                                ערוך תשלום
                                            </li>
                                            <li className="pointer"
                                                onClick={() => { this.onMenuClick('serviceReporter') }}
                                            >
                                                צור כתב שירות
                                            </li>

                                            <li className="pointer"
                                                onClick={() => { this.onMenuClick('renewRider') }}
                                            >
                                                חידוש מנוי
                                            </li>


                                            {/* <li className="pointer">חידוש מנוי</li> */}
                                            {this.isAdmin() ?
                                                <li className={this.props.data.riderStatusType != 2 ? "pointer" : "hide"}
                                                    onClick={() => { this.onMenuClick('editEndDate') }}
                                                >
                                                    עדכון סיום מנוי</li>
                                                : ""}


                                            {this.isAdmin() ?
                                                <li className={this.props.data.additionNumber == 0 ? "pointer" : "hide"}
                                                    onClick={() => { this.onMenuClick('showLog') }}
                                                >
                                                    הצג לוג</li>
                                                : ""}
                                        </ul>


                                    )}
                                </div>
                                <div className={this.props.isChild && this.isAdmin() ? "cell" : "hide"} >
                                    <button className="act-btn has-icon flex-justify-center"
                                        onClick={() => { this.props.onShowLogClick(this.props.data) }}
                                    >
                                        הצג לוג
                                    </button>

                                </div>
                            </div>
                        </div>
                        <div className={this.state.open ? 'children' : 'hide'}>
                            {this.renderChildren()}
                        </div>
                    </>
                ) : ""}
            </>
        );
    }
}
